// ============================================================
// useSessionTracker — Hook per gestire lo span radice della
// sessione utente.
//
// Deve essere chiamato una volta sola, idealmente nel
// componente App o nel primo componente montato. Crea lo
// span radice 'session' che fa da parent per tutti gli span
// pagina generati da useComponentMetric.
//
// Uso: const session = useSessionTracker();
//      // all'atterraggio della pagina
//      session.trackLandingEvent();
//      // quando l'utente crea appuntamento
//      session.trackCreateAppointmentEvent();
//      // quando la sessione termina (opzionale)
//      session.trackSessionEndEvent();
// ============================================================

import { useEffect, useRef, useCallback } from 'react';
import {
  trackSpanSessionStart,
  trackSpanSessionEnd,
  trackSpanCreateAppointment,
  trackLanding,
  trackCreateAppointment,
  hasActiveContext,
} from './otelExporter';

export default function useSessionTracker() {
  const startedRef = useRef(false);

  // All mount: avvia lo span radice di sessione
  useEffect(() => {
    if (!startedRef.current) {
      startedRef.current = true;
      trackSpanSessionStart();
    }

    return () => {
      // Cleanup: chiudi sessione se ancora aperta
      if (hasActiveContext()) {
        trackSpanSessionEnd();
      }
      startedRef.current = false;
    };
  }, []);

  const trackLandingEvent = useCallback(() => {
    trackLanding();
  }, []);

  const trackCreateAppointmentEvent = useCallback(() => {
    trackCreateAppointment();
    trackSpanCreateAppointment();
  }, []);

  const trackSessionEndEvent = useCallback(() => {
    if (hasActiveContext()) {
      trackSpanSessionEnd();
    }
  }, []);

  return {
    trackLandingEvent,
    trackCreateAppointmentEvent,
    trackSessionEndEvent,
  };
}
